import { useState, useEffect } from 'react';
import { WifiOff } from 'lucide-react';

/**
 * Shows a sticky banner when the user is offline (navigator.onLine === false).
 * Rendered in App.tsx so it appears above main content.
 */
export function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div
      className="sticky top-0 z-[70] bg-amber-600 text-white py-2 px-4 text-center text-sm font-medium flex items-center justify-center gap-2"
      role="status"
      aria-live="polite"
    >
      <WifiOff className="w-4 h-4 shrink-0" aria-hidden />
      <span>Du er offline. Noen funksjoner kan være utilgjengelige.</span>
    </div>
  );
}
